import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
} from '../../components/ui/select';
import { Path } from '../../lib/types';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../../components/ui/tooltip';

function PathSelector({
  selectedPath,
  paths,
  handleChange,
}: {
  selectedPath: Path | undefined;
  paths: Path[] | [];
  handleChange: (pathId: string) => void;
}) {
  return (
    <Select
      value={selectedPath?.name}
      onValueChange={(pathId: string) => {
        handleChange(pathId);
      }}
    >
      <SelectTrigger className="lg:min-w-[20rem] bg-white text-black">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger className=" truncate !max-w-32 xs:!max-w-full">
              <span>{selectedPath?.name}</span>
            </TooltipTrigger>
            <TooltipContent>
              <p>{selectedPath?.name}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
        {/* <SelectValue placeholder={selectedPath?.name} className="truncate" /> */}
      </SelectTrigger>
      <SelectContent className="bg-white text-black">
        <SelectGroup>
          <SelectLabel className="!pl-2 md:!pl-4">Paths</SelectLabel>
          {paths?.length !== 0 &&
            paths?.map((path: Path, index: number) => {
              return (
                <SelectItem
                  className="!pl-2 md:!pl-4"
                  value={`${path.id}`}
                  key={index}
                >
                  {path.name}
                </SelectItem>
              );
            })}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}

export default PathSelector;
